import { RecipesCategoriesActions } from "../action-types/recipesCategories-action.types";

const INITIAL_STATE: any = {
  recipesCategoriesForUpdate: undefined,
  isUpdateRecipesCategory: false,
  recipesCategoriesModalIsOpen: false,
  refreshTableRecipesCategories: false,
};

export default function recipesCategoriesReducer(
  state: any = INITIAL_STATE,
  action: RecipesCategoriesActions
): any {
  switch (action.type) {
    case "[ RECIPES_CATEGORIES ] Get RECIPES_CATEGORY For Update":
      return {
        ...state,
        recipesCategoriesForUpdate: action.payload,
      };
    case "[ RECIPES_CATEGORIES ] Is RECIPES_CATEGORY For Update":
      return {
        ...state,
        isUpdateRecipesCategory: action.payload,
      };
    case "[ RECIPES_CATEGORIES ] Switch RECIPES_CATEGORIES Refresh Table":
      return {
        ...state,
        refreshTableRecipesCategories: action.payload,
      };
    case "[ RECIPES_CATEGORIES ] Recipes Categories Modal State":
      return {
        ...state,
        recipesCategoriesModalIsOpen: action.payload,
      };
    default:
      return state;
  }
}
